{
  "deprecatedBrowser": "不支援您的瀏覽器",
  "deprecatedBrowserHelpText": "請考慮將您的瀏覽器更新至最新版本，以確保擁有最佳體驗。"
}
